import { Button, Col, Grid, Inline, Stack } from "@sembark-travel/ui-base"
import {
	Form,
	SelectField,
	SubmissionError,
	TextInputField,
	validateFormValues,
	withServerErrors,
} from "@sembark-travel/ui-form"
import { useXHR } from "@sembark-travel/xhr"
import { useMemo } from "react"
import { Optional } from "utility-types"
import * as Validator from "yup"
import { IDocType } from "./store"
import { SelectTripDestination } from "../TripDestinations"

export function NewDocumentTypeItem({
	onSuccess,
	onCancel,
	initialValues,
}: {
	onSuccess: (tripSource: IDocType) => void
	onCancel?: () => void
	initialValues?: { name: IDocType["name"] }
}) {
	const xhr = useXHR()
	return (
		<NewItemForm
			onCancel={onCancel}
			onSubmit={async (values: IDocType) => {
				const data = {
					name: values.name,
					destinations: values.destinations.map((des) => des.id),
				}
				const doc = await xhr.post("/document-types", data)
				onSuccess(doc.data.data)
				return doc
			}}
			initialValues={initialValues}
		/>
	)
}

const validationSchema = Validator.object().shape({
	name: Validator.string().required("Please provide name for the Document"),
})

export function NewItemForm({
	onSubmit,
	onCancel,
	initialValues: propInitialValues,
}: {
	onSubmit: (data: IDocType) => Promise<unknown>
	onCancel?: () => void
	initialValues?: Optional<IDocType>
}) {
	const initialValues: Partial<IDocType> = useMemo(() => {
		return {
			name: propInitialValues?.name || "",
			destinations: propInitialValues?.destinations || [],
		}
	}, [propInitialValues])

	return (
		<Form<IDocType>
			initialValues={initialValues}
			validate={validateFormValues(validationSchema)}
			onSubmit={withServerErrors(async (values) => {
				await onSubmit(values)
			})}
			subscription={{ submitting: true }}
		>
			{({ submitting, handleSubmit }) => (
				<form noValidate onSubmit={handleSubmit}>
					<Grid gap="4">
						<Col sm={6}>
							<TextInputField
								label="Name"
								name="name"
								type="text"
								placeholder="e.g. Govt. ID"
								required
							/>
						</Col>
						<Col sm={5}>
							<SelectField
								name="destinations"
								label="Destinations"
								select={SelectTripDestination}
								multiple
								placeholder="Select destinations..."
								fetchOnMount
							/>
						</Col>
						<Col sm={12}>
							<Stack gap="4">
								<SubmissionError />
								<Inline gap="4">
									<Button type="submit" disabled={submitting}>
										{submitting ? "Saving..." : "Save Details"}
									</Button>
									{onCancel ? (
										<Button onClick={onCancel} level="tertiary">
											Cancel
										</Button>
									) : null}
								</Inline>
							</Stack>
						</Col>
					</Grid>
				</form>
			)}
		</Form>
	)
}
